/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ErrorDefDTO { 
    args?: Array<string>;
    detailedErrorMessage?: string;
    errorCode?: string;
    showDetailsToTenant?: boolean;
}

